import React from 'react';
import ScheduleApp from '../components/ScheduleApp';

const Home = () => {
  return (
    <>
      <ScheduleApp />
    </>
  );
};

export default Home;
